module.exports = __webpack_public_path__ + "img/local-22.75b043c1.jpg";